import * as React from 'react';

function SvgConfirm(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} {...props}>
      <g data-name="Rectangle 328" stroke={props.fill} fill="none">
        <rect width={14} height={14} rx={3} stroke="none" />
        <rect width={13} height={13} x={0.5} y={0.5} rx={2.5} />
      </g>
      <text
        transform="translate(7 10)"
        fontSize={9}
        fontFamily="Montserrat-SemiBold,Montserrat"
        fontWeight={600}
      >
        <tspan x={-3.271} y={0}>
          {'C'}
        </tspan>
      </text>
    </svg>
  );
}

export default SvgConfirm;
